module.exports = __webpack_public_path__ + "img/0.0977e166.png";